import { render, staticRenderFns } from "./BrightonCity.vue?vue&type=template&id=37bd575e&scoped=true&"
import script from "./BrightonCity.vue?vue&type=script&lang=js&"
export * from "./BrightonCity.vue?vue&type=script&lang=js&"
import style0 from "./BrightonCity.vue?vue&type=style&index=0&id=37bd575e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd575e",
  null
  
)

export default component.exports